import { render, staticRenderFns } from "./Screw.vue?vue&type=template&id=7821ff6c"
import script from "./Screw.vue?vue&type=script&lang=js"
export * from "./Screw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports